import React, { useEffect } from 'react';
import styles from './styles.scss';

export default function InspectionPage() {
	useEffect(() => {
		document.title = 'Brand Introduction | AirClass';
	}, []);

	return (
		<div className={styles.page}>
			<main className={styles.main}>
				<section className={styles.intro}>
					<h1>Brand Introduction</h1>
					<div className={styles.quoteCard}>
						<span className={`${styles.quoteMark} ${styles.quoteStart}`}>“</span>
						<p>
							Our company was founded by a team of seasoned corporate executives with extensive experience in cross-border business, together with co-investment from multiple top-tier international capital firms. Leveraging a globally oriented core operational structure and the strategic advantages of two major international financial and commercial hubs, we have successfully established connectivity between the two core markets of Asia-Pacific and Europe. Built upon the founding team&apos;s proven experience in managing multinational enterprises, global industry vision, and the empowerment of international capital, our company has been committed to an international development path from the very beginning. We have built a comprehensive business system that enables cross-regional operations, localized execution, and global resource integration. As a result, we are able to simultaneously tap into mature market opportunities in Europe and the Americas as well as growth dividends in the Asia-Pacific region. With naturally differentiated strengths in cross-border business synergy, international service delivery, and global strategic positioning, we are steadily advancing our long-term globalization strategy.
						</p>
						<span className={`${styles.quoteMark} ${styles.quoteEnd}`}>”</span>
					</div>
				</section>
			</main>
			<footer className={styles.footer}>沪ICP备2022013021号-4</footer>
		</div>
	);
}
